'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import ZemeFooter from '@src/v3/assets/svg/zemeFooter';
import { FOOTER_COLUMNS } from '@src/v3/constants/routes';
import { FooterColumn } from '@src/v3/interfaces/components/landingPageFooter';
import { APP_STORE_URL, GOOGLE_PLAY_STORE_URL } from '@src/v3/constants/common';

const LandingPageFooter = () => {
  return (
    <footer className="relative w-full bg-[#F9F9F9] border-t border-gray-200 overflow-hidden mt-12">
      {/* Main footer content */}
      <div className="relative z-10 mx-auto px-6 sm:px-10 pt-8 pb-6">
        <div className="flex flex-col md:flex-row gap-10 ">
          {/* Footer columns */}
          <div className="grid grid-cols-2 sm:grid-cols-5 flex-1">
            {FOOTER_COLUMNS.map((column: FooterColumn) => (
              <div
                key={column.title}
                className={`flex flex-col gap-4 ${column.className || ''}`}
              >
                <h3 className="text-base font-medium text-gray-1000">
                  {column.title}
                </h3>
                <ul className="flex flex-col gap-4">
                  {column.links
                    .filter((link) => link.isVisible)
                    .map((link) => (
                      <li key={link.label}>
                        <Link
                          href={link.value}
                          className="text-base font-light text-gray-1000 hover:text-gray-700 transition-colors"
                          target={link.isExternal ? '_blank' : undefined}
                          rel={
                            link.isExternal ? 'noopener noreferrer' : undefined
                          }
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
            {/* App store buttons */}
            <div className="flex flex-col gap-3 shrink-0">
              <Link
                href={GOOGLE_PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Image
                  src="/assets/landing-page/play-store.png"
                  alt="Get it on Google Play"
                  width={170}
                  height={50}
                  className="h-[50px] w-auto object-contain"
                />
              </Link>
              <Link
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Image
                  src="/assets/landing-page/app-store.png"
                  alt="Download on the App Store"
                  width={170}
                  height={50}
                  className="h-[50px] w-auto object-contain"
                />
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="flex justify-end mt-16 pb-[350px]">
          <p className="text-base font-normal text-gray-1000">
            © {new Date().getFullYear()} Zeme
          </p>
        </div>
      </div>

      {/* Background Zeme logo */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full pointer-events-none">
        <ZemeFooter className="w-full h-auto" />
      </div>
    </footer>
  );
};

export default LandingPageFooter;
